import React, { useEffect, useRef, useState } from "react";
import "./Faq.scss";

import { ServerInterface } from "../ServerInterface";

export default function Faq() {
  const [showFaq, setShowFaq] = useState(false);
  const [faqHtml, setFaqHtml] = useState<string | undefined>(undefined);
  const currentTopic = useRef<any | undefined>();

  async function loadFaqs() {
    const data = await ServerInterface.loadFaqs();

    var converter = new (window as any).showdown.Converter();
    const htmlFAQ = converter.makeHtml(data);

    setFaqHtml(htmlFAQ);
  }

  useEffect(() => {
    showHideTopic(currentTopic.current);
  });

  useEffect(() => {
    loadFaqs();
  }, []);

  function showHideTopic(topicHeader: any | undefined) {
    var found = false;
    const children = $("#FaqText")[0]?.children;

    if (children) {
      for (var c = 0; c < children.length; c++) {
        const child = children[c];
        if (child.tagName == "H1") {
          found = false;
        }
        if (child == topicHeader) {
          found = true;
        }
        if (child.tagName != "H1") {
          (child as any).style.display = found ? "inherit" : "none";
        }
      }
    }
  }

  function onClick(ev: any) {
    if (currentTopic.current == ev.target) {
      currentTopic.current = undefined;
    } else {
      currentTopic.current = ev.target;
    }
    showHideTopic(currentTopic.current);
  }

  return (
    <div
      style={{
        overflow: "hidden",
        width: "100%",
        paddingTop: "20px",
        marginBottom: "20px",
        boxShadow: "silver 5px 5px 20px",
        backgroundColor: "#f0f0f0f0",

        position: "relative",
        maxWidth: "100%",
        height: "max-content",
        borderRadius: "10px",
        border: "1px solid grey",
        padding: "20px",
      }}
      onClick={onClick}
    >
      <div id="gotoFAQ" style={{ fontSize: "1em" }}>
        <span style={{ fontWeight: "bold" }}>Zum Reservieren </span>
        <span style={{ fontWeight: "normal" }}>
          tippe unten in der Platzübersicht <br />
          auf eine Stunde auf einem Platz.
          <br />
        </span>
        <br />

        {!showFaq && (
          <div>
            <u
              style={{
                fontSize: "1em",
                fontWeight: "bold",
                cursor: "pointer",
                color: "blue",
              }}
              onClick={() => {
                setShowFaq(!showFaq);
              }}
            >
              Hier&nbsp;
            </u>

            <span style={{ fontSize: "1em", fontWeight: "normal" }}>findest Antworten auf häufige Fragen zur Platzreservierung...</span>
          </div>
        )}

        {showFaq && (
          <div
            style={{
              paddingTop: "1em",
              fontSize: "1em",
              fontWeight: "bold",
              cursor: "pointer",
              color: "blue",
            }}
            onClick={() => {
              setShowFaq(!showFaq);
            }}
          >
            <u>Faq wieder schließen</u>
          </div>
        )}
      </div>

      {showFaq && faqHtml && <div id="FaqText" className="faqText" dangerouslySetInnerHTML={{ __html: faqHtml }} />}
    </div>
  );
}
